// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__5niV9","alertIcon":"ConfirmModal_alertIcon__3vIy2"};